import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { getCurrentUser, getToken, logout, getMesReservations } from "../utils/api";

// ── Icônes ───────────────────────────────────────────────────
const IconUser = ({ size = 20, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
  </svg>
);
const IconEdit = ({ size = 16, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
  </svg>
);
const IconCalendar = ({ size = 16, color = "#7A5A3A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);
const IconPin = ({ size = 13, color = "#7A5A3A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
  </svg>
);
const IconCheck = ({ size = 16, color = "#3D6B2E" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
const IconLogout = ({ size = 16, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
    <polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
  </svg>
);
const IconPhone = ({ size = 16, color = "#7A5A3A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.56 1.18h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 8.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);
const IconMail = ({ size = 16, color = "#7A5A3A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);
const IconClock = ({ size = 18, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
  </svg>
);
const IconHome = ({ size = 15, color = "#1C1008" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
);

// ── Labels rôles ──────────────────────────────────────────────
const roleLabels = {
  client:       { label: "Voyageur",     color: "#3D6B2E", bg: "rgba(61,107,46,.1)"  },
  bailleur:     { label: "Bailleur",     color: "#C4441A", bg: "rgba(196,68,26,.1)"  },
  chauffeur:    { label: "Chauffeur",    color: "#1A6B8B", bg: "rgba(26,107,139,.1)" },
  restaurateur: { label: "Restaurateur", color: "#8B6914", bg: "rgba(139,105,20,.1)" },
  admin:        { label: "Admin",        color: "#6B3D8B", bg: "rgba(107,61,139,.1)" },
};

const statutConfig = {
  en_attente: { label: "En attente",  bg: "rgba(139,105,20,.1)",  color: "#8B6914"  },
  confirmee:  { label: "Confirmée",   bg: "rgba(61,107,46,.1)",   color: "#3D6B2E"  },
  a_venir:    { label: "À venir",     bg: "rgba(61,107,46,.1)",   color: "#3D6B2E"  },
  terminee:   { label: "Terminée",    bg: "rgba(28,16,8,.07)",    color: "#7A5A3A"  },
  annulee:    { label: "Annulée",     bg: "rgba(196,68,26,.1)",   color: "#C4441A"  },
};

// ── Compte à rebours ──────────────────────────────────────────
function ComptaRebours({ dateDepart }) {
  const [reste, setReste] = useState("");

  useEffect(() => {
    const calc = () => {
      const diff = new Date(dateDepart) - new Date();
      if (diff <= 0) { setReste("Séjour terminé"); return; }
      const j = Math.floor(diff / (1000 * 60 * 60 * 24));
      const h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      setReste(`${j}j ${h}h ${m}m`);
    };
    calc();
    const t = setInterval(calc, 60000);
    return () => clearInterval(t);
  }, [dateDepart]);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6, background: "rgba(196,68,26,.08)", borderRadius: 8, padding: "8px 12px", marginTop: 10 }}>
      <IconClock size={14} color="#C4441A" />
      <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 700, color: "#C4441A" }}>
        Fin du séjour dans : {reste}
      </span>
    </div>
  );
}

// ── Composant principal ───────────────────────────────────────
export default function Profil() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [reservations, setReservations] = useState([]);
  const [loadingResa, setLoadingResa] = useState(true);
  const [onglet, setOnglet] = useState("reservations");
  const [editMode, setEditMode] = useState(false);
  const [formInfos, setFormInfos] = useState({});
  const [saving, setSaving] = useState(false);
  const [saveMsg, setSaveMsg] = useState("");

  // ── Charger l'utilisateur depuis localStorage
  useEffect(() => {
    const u = getCurrentUser();
    if (!u) {
      navigate("/connexion");
      return;
    }
    setUser(u);
    setFormInfos({
      nom: u.nom || "",
      email: u.email || "",
      telephone: u.telephone || "",
      ville: u.ville || "",
    });
  }, [navigate]);

  // ── Charger les réservations depuis l'API
  useEffect(() => {
    if (!getToken()) return;
    const load = async () => {
      setLoadingResa(true);
      try {
        const data = await getMesReservations();
        setReservations(data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoadingResa(false);
      }
    };
    load();
  }, []);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await fetch("https://senutour.com/api/auth/profile", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(formInfos),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      // Mettre à jour le localStorage
      const updated = { ...user, ...formInfos };
      localStorage.setItem("user", JSON.stringify(updated));
      setUser(updated);
      setEditMode(false);
      setSaveMsg("Profil mis à jour !");
      setTimeout(() => setSaveMsg(""), 3000);
    } catch (e) {
      setSaveMsg("Erreur : " + e.message);
    } finally {
      setSaving(false);
    }
  };

  const formatPrix = (p) => p?.toLocaleString("fr-FR") + " FCFA";
  const formatDate = (d) =>
    d ? new Date(d).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" }) : "";

  // Séjour en cours : arrivée passée ET départ futur
  const maintenant = new Date();
  const sejourEnCours = reservations.find(r =>
    r.statut === "confirmee" &&
    new Date(r.dateArrivee) <= maintenant &&
    new Date(r.dateDepart) >= maintenant
  );

  if (!user) return null;

  const roleInfo = roleLabels[user.role] || roleLabels["client"];
  const initiales = user.nom ? user.nom.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2) : "??";

  const dateInscription = user.createdAt
    ? new Date(user.createdAt).toLocaleDateString("fr-FR", { month: "long", year: "numeric" })
    : "Récemment";

  return (
    <div style={{ fontFamily: "'Fraunces', serif", background: "#FAF5EC", color: "#1C1008", minHeight: "100vh" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,700;0,9..144,800;1,9..144,400&family=Space+Grotesk:wght@400;500;600;700&display=swap');
        * { margin: 0; padding: 0; box-sizing: border-box; }

        .form-input {
          width: 100%; padding: 12px 14px;
          border: 1.5px solid #E8DCC8; border-radius: 8px;
          font-family: 'Space Grotesk', sans-serif; font-size: 14px;
          color: #1C1008; background: white; outline: none; transition: all .25s;
        }
        .form-input:focus { border-color: #C4441A; box-shadow: 0 0 0 3px rgba(196,68,26,.08); }
        .form-input:disabled { background: #FAF5EC; color: #7A5A3A; border-color: #E8DCC8; cursor: default; }

        .resa-card {
          background: white; border-radius: 14px; overflow: hidden;
          border: 1.5px solid rgba(28,16,8,.06); transition: all .3s;
        }
        .resa-card:hover { box-shadow: 0 12px 36px rgba(28,16,8,.1); transform: translateY(-3px); }

        .btn-primary {
          background: #C4441A; color: white; border: none;
          padding: 12px 24px; border-radius: 8px;
          font-family: 'Space Grotesk', sans-serif; font-size: 14px; font-weight: 600;
          cursor: pointer; transition: all .3s;
        }
        .btn-primary:hover { background: #A03614; transform: translateY(-1px); }
        .btn-primary:disabled { opacity: .6; cursor: not-allowed; transform: none; }

        .btn-outline {
          background: transparent; color: #7A5A3A;
          border: 1.5px solid rgba(28,16,8,.15); padding: 11px 22px;
          border-radius: 8px; font-family: 'Space Grotesk', sans-serif;
          font-size: 14px; font-weight: 600; cursor: pointer; transition: all .3s;
        }
        .btn-outline:hover { border-color: #C4441A; color: #C4441A; }

        @keyframes fadeUp { from { opacity: 0; transform: translateY(14px); } to { opacity: 1; transform: translateY(0); } }
        .fade-up { animation: fadeUp .45s ease forwards; }

        @media(max-width: 900px) { .profil-grid { grid-template-columns: 1fr !important; } }
        @media(max-width: 767px) {
          .profil-content { padding: 32px 5% 60px !important; }
          .resa-inner { flex-direction: column !important; }
          .resa-img { width: 100% !important; height: 160px !important; }
        }
      `}</style>

      <Navbar transparent={false} />

      <section className="profil-content" style={{ padding: "88px 5% 80px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div className="profil-grid" style={{ display: "grid", gridTemplateColumns: "300px 1fr", gap: 32, alignItems: "start" }}>

            {/* ── SIDEBAR ── */}
            <div style={{ position: "sticky", top: 88 }}>

              {/* Carte identité */}
              <div style={{ background: "white", borderRadius: 16, padding: "28px 24px", border: "1.5px solid rgba(28,16,8,.08)", boxShadow: "0 4px 20px rgba(28,16,8,.07)", marginBottom: 14, textAlign: "center" }}>
                <div style={{ width: 80, height: 80, borderRadius: "50%", background: "linear-gradient(135deg, #C4441A, #E8834A)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px", boxShadow: "0 6px 20px rgba(196,68,26,.25)" }}>
                  <span style={{ fontFamily: "'Fraunces',serif", fontSize: 28, fontWeight: 800, color: "white" }}>{initiales}</span>
                </div>

                <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 22, fontWeight: 800, marginBottom: 4 }}>
                  {user.nom}
                </h2>

                <div style={{ display: "inline-flex", alignItems: "center", gap: 6, background: roleInfo.bg, borderRadius: 20, padding: "4px 12px", marginBottom: 16 }}>
                  <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, fontWeight: 700, color: roleInfo.color }}>
                    {roleInfo.label}
                  </span>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: 8, textAlign: "left", marginBottom: 20 }}>
                  {[
                    { icon: <IconMail size={14} />,     val: user.email },
                    { icon: <IconPhone size={14} />,    val: user.telephone || "Non renseigné" },
                    { icon: <IconPin size={14} />,      val: user.ville || "Non renseigné" },
                    { icon: <IconCalendar size={14} />, val: `Membre depuis ${dateInscription}` },
                  ].map((item, i) => (
                    <div key={i} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <div style={{ color: "#7A5A3A", flexShrink: 0, display: "flex" }}>{item.icon}</div>
                      <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, color: "#7A5A3A", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {item.val}
                      </span>
                    </div>
                  ))}
                </div>

                <button className="btn-outline" style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}
                  onClick={() => { setOnglet("infos"); setEditMode(true); }}>
                  <IconEdit size={14} color="#7A5A3A" /> Modifier le profil
                </button>
              </div>

              {/* Navigation */}
              <div style={{ background: "white", borderRadius: 14, border: "1.5px solid rgba(28,16,8,.06)", overflow: "hidden", marginBottom: 14 }}>
                {[
                  { key: "reservations", label: "Mes réservations", Icon: IconCalendar },
                  { key: "infos",        label: "Mes informations",  Icon: IconUser    },
                ].map(({ key, label, Icon }, i, arr) => (
                  <button key={key} onClick={() => { setOnglet(key); setEditMode(false); }}
                    style={{ width: "100%", padding: "14px 18px", border: "none", borderBottom: i < arr.length - 1 ? "1px solid rgba(28,16,8,.05)" : "none", background: onglet === key ? "rgba(196,68,26,.06)" : "white", color: onglet === key ? "#C4441A" : "#7A5A3A", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 600, cursor: "pointer", textAlign: "left", display: "flex", alignItems: "center", gap: 10, borderLeft: onglet === key ? "3px solid #C4441A" : "3px solid transparent", transition: "all .2s" }}>
                    <Icon size={16} color={onglet === key ? "#C4441A" : "#7A5A3A"} />
                    {label}
                  </button>
                ))}
              </div>

              {/* Déconnexion */}
              <button onClick={handleLogout}
                style={{ width: "100%", padding: "12px 18px", border: "1.5px solid rgba(196,68,26,.2)", borderRadius: 12, background: "white", color: "#C4441A", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 600, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 8, transition: "all .2s" }}
                onMouseEnter={e => e.currentTarget.style.background = "rgba(196,68,26,.05)"}
                onMouseLeave={e => e.currentTarget.style.background = "white"}>
                <IconLogout size={15} color="#C4441A" /> Se déconnecter
              </button>
            </div>

            {/* ── CONTENU ── */}
            <div className="fade-up" key={onglet}>

              {/* ━━ MES RÉSERVATIONS ━━ */}
              {onglet === "reservations" && (
                <div>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 28, flexWrap: "wrap", gap: 12 }}>
                    <div>
                      <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 28, fontWeight: 800, letterSpacing: "-0.5px" }}>
                        Mes réservations
                      </h2>
                      {!loadingResa && (
                        <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, color: "#7A5A3A", marginTop: 4 }}>
                          {reservations.length} réservation{reservations.length > 1 ? "s" : ""} au total
                        </p>
                      )}
                    </div>
                    <button className="btn-primary" onClick={() => navigate("/hotels")}>
                      + Nouvelle réservation
                    </button>
                  </div>

                  {/* Séjour en cours avec compte à rebours */}
                  {sejourEnCours && (
                    <div style={{ background: "rgba(196,68,26,.05)", border: "1.5px solid rgba(196,68,26,.2)", borderRadius: 14, padding: "20px 24px", marginBottom: 24 }}>
                      <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, fontWeight: 700, color: "#C4441A", textTransform: "uppercase", letterSpacing: 1, marginBottom: 6 }}>
                        Séjour en cours
                      </p>
                      <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 18, fontWeight: 700, marginBottom: 4 }}>
                        {sejourEnCours.hebergement?.nom || sejourEnCours.nomHebergement || "Hébergement"}
                      </h3>
                      <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: "#7A5A3A" }}>
                        Jusqu'au {formatDate(sejourEnCours.dateDepart)}
                      </p>
                      <ComptaRebours dateDepart={sejourEnCours.dateDepart} />
                    </div>
                  )}

                  {/* Loading */}
                  {loadingResa && (
                    <div style={{ textAlign: "center", padding: "60px 20px", background: "white", borderRadius: 14, border: "1.5px solid rgba(28,16,8,.06)" }}>
                      <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, color: "#7A5A3A" }}>Chargement...</p>
                    </div>
                  )}

                  {/* Liste vide */}
                  {!loadingResa && reservations.length === 0 && (
                    <div style={{ textAlign: "center", padding: "80px 20px", background: "white", borderRadius: 16, border: "1.5px solid rgba(28,16,8,.06)" }}>
                      <div style={{ width: 72, height: 72, borderRadius: "50%", background: "rgba(196,68,26,.08)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
                        <IconHome size={32} color="#C4441A" />
                      </div>
                      <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 22, fontWeight: 700, marginBottom: 10 }}>
                        Aucune réservation pour l'instant
                      </h3>
                      <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, color: "#7A5A3A", marginBottom: 24 }}>
                        Commencez à explorer les hébergements du Sénégal !
                      </p>
                      <button className="btn-primary" onClick={() => navigate("/hotels")}>
                        Explorer les hébergements
                      </button>
                    </div>
                  )}

                  {/* Cards réservations */}
                  {!loadingResa && reservations.length > 0 && (
                    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                      {reservations.map((r, i) => {
                        const sc = statutConfig[r.statut] || statutConfig["en_attente"];
                        const nomHeberg = r.hebergement?.nom || r.nomHebergement || "Hébergement";
                        const villeHeberg = r.hebergement?.ville || r.ville || "";
                        const imgHeberg = r.hebergement?.images?.[0] || null;

                        // Séjour en cours pour cette réservation
                        const enCours = r.statut === "confirmee" &&
                          new Date(r.dateArrivee) <= maintenant &&
                          new Date(r.dateDepart) >= maintenant;

                        return (
                          <div key={r.id || i} className="resa-card">
                            <div className="resa-inner" style={{ display: "flex" }}>
                              {/* Image ou placeholder */}
                              <div className="resa-img" style={{ width: 130, flexShrink: 0, overflow: "hidden", position: "relative", background: "#F0E8D4" }}>
                                {imgHeberg
                                  ? <img src={imgHeberg} alt={nomHeberg} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block", minHeight: 140 }} />
                                  : <div style={{ width: "100%", minHeight: 140, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                      <IconHome size={36} color="#C4441A" />
                                    </div>
                                }
                              </div>

                              {/* Contenu */}
                              <div style={{ flex: 1, padding: "18px 20px", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 8 }}>
                                  <div>
                                    <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: 2, color: "#C4441A", textTransform: "uppercase", display: "block", marginBottom: 4 }}>
                                      #{r.id}
                                    </span>
                                    <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 19, fontWeight: 700, marginBottom: 4 }}>
                                      {nomHeberg}
                                    </h3>
                                    {villeHeberg && (
                                      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                        <IconPin size={11} color="#B8A898" />
                                        <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, color: "#B8A898" }}>{villeHeberg}, Sénégal</span>
                                      </div>
                                    )}
                                  </div>
                                  <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, fontWeight: 700, background: sc.bg, color: sc.color, padding: "4px 12px", borderRadius: 20, flexShrink: 0 }}>
                                    {sc.label}
                                  </span>
                                </div>

                                <div style={{ marginTop: 14 }}>
                                  <div style={{ display: "flex", gap: 20, flexWrap: "wrap", marginBottom: 10 }}>
                                    {[
                                      { label: "Arrivée",  val: formatDate(r.dateArrivee) },
                                      { label: "Départ",   val: formatDate(r.dateDepart) },
                                      { label: "Durée",    val: `${r.nbNuits} nuit${r.nbNuits > 1 ? "s" : ""}` },
                                      { label: "Total estimé", val: formatPrix(r.totalEstime) },
                                    ].map((item, j) => (
                                      <div key={j}>
                                        <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 11, color: "#B8A898", marginBottom: 2 }}>{item.label}</div>
                                        <div style={{ fontFamily: item.label === "Total estimé" ? "'Fraunces',serif" : "'Space Grotesk',sans-serif", fontSize: item.label === "Total estimé" ? 15 : 13, fontWeight: item.label === "Total estimé" ? 800 : 600, color: item.label === "Total estimé" ? "#C4441A" : "#1C1008" }}>
                                          {item.val}
                                        </div>
                                      </div>
                                    ))}
                                  </div>

                                  {/* Compte à rebours si séjour en cours */}
                                  {enCours && <ComptaRebours dateDepart={r.dateDepart} />}

                                  {/* Message en attente */}
                                  {r.statut === "en_attente" && (
                                    <div style={{ display: "flex", alignItems: "center", gap: 6, background: "rgba(139,105,20,.08)", borderRadius: 8, padding: "8px 12px", marginTop: 8 }}>
                                      <IconClock size={13} color="#8B6914" />
                                      <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, color: "#8B6914" }}>
                                        En cours de vérification — notre équipe vous contacte sous 24h
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}

              {/* ━━ MES INFORMATIONS ━━ */}
              {onglet === "infos" && (
                <div>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 28, flexWrap: "wrap", gap: 12 }}>
                    <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 28, fontWeight: 800, letterSpacing: "-0.5px" }}>
                      Mes informations
                    </h2>
                    <button className={editMode ? "btn-primary" : "btn-outline"}
                      style={{ display: "flex", alignItems: "center", gap: 6 }}
                      disabled={saving}
                      onClick={() => editMode ? handleSave() : setEditMode(true)}>
                      {saving ? "Enregistrement..." : editMode
                        ? <><IconCheck size={15} color="white" /> Enregistrer</>
                        : <><IconEdit size={14} color="#7A5A3A" /> Modifier</>
                      }
                    </button>
                  </div>

                  {saveMsg && (
                    <div style={{ background: saveMsg.startsWith("Erreur") ? "rgba(196,68,26,.08)" : "rgba(61,107,46,.08)", border: `1.5px solid ${saveMsg.startsWith("Erreur") ? "rgba(196,68,26,.2)" : "rgba(61,107,46,.2)"}`, borderRadius: 8, padding: "12px 16px", marginBottom: 20 }}>
                      <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: saveMsg.startsWith("Erreur") ? "#C4441A" : "#3D6B2E", margin: 0 }}>
                        {saveMsg}
                      </p>
                    </div>
                  )}

                  <div style={{ background: "white", borderRadius: 16, padding: "32px", border: "1.5px solid rgba(28,16,8,.07)" }}>
                    <div style={{ marginBottom: 20 }}>
                      <label style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, fontWeight: 700, color: "#1C1008", display: "block", marginBottom: 8, textTransform: "uppercase", letterSpacing: 1 }}>Nom complet</label>
                      <input className="form-input" value={formInfos.nom || ""} disabled={!editMode}
                        onChange={e => setFormInfos({ ...formInfos, nom: e.target.value })} />
                    </div>
                    <div style={{ marginBottom: 20 }}>
                      <label style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, fontWeight: 700, color: "#1C1008", display: "block", marginBottom: 8, textTransform: "uppercase", letterSpacing: 1 }}>Email</label>
                      <input className="form-input" type="email" value={formInfos.email || ""} disabled={!editMode}
                        onChange={e => setFormInfos({ ...formInfos, email: e.target.value })} />
                    </div>
                    <div style={{ marginBottom: 20 }}>
                      <label style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, fontWeight: 700, color: "#1C1008", display: "block", marginBottom: 8, textTransform: "uppercase", letterSpacing: 1 }}>Téléphone</label>
                      <input className="form-input" value={formInfos.telephone || ""} disabled={!editMode}
                        onChange={e => setFormInfos({ ...formInfos, telephone: e.target.value })} />
                    </div>
                    <div style={{ marginBottom: 20 }}>
                      <label style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, fontWeight: 700, color: "#1C1008", display: "block", marginBottom: 8, textTransform: "uppercase", letterSpacing: 1 }}>Ville</label>
                      <input className="form-input" value={formInfos.ville || ""} disabled={!editMode}
                        onChange={e => setFormInfos({ ...formInfos, ville: e.target.value })} />
                    </div>

                    {/* Rôle — non modifiable */}
                    <div>
                      <label style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, fontWeight: 700, color: "#1C1008", display: "block", marginBottom: 8, textTransform: "uppercase", letterSpacing: 1 }}>Rôle</label>
                      <div style={{ display: "inline-flex", alignItems: "center", gap: 6, background: roleInfo.bg, borderRadius: 8, padding: "10px 16px" }}>
                        <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700, color: roleInfo.color }}>
                          {roleInfo.label}
                        </span>
                      </div>
                    </div>

                    {!editMode && (
                      <div style={{ display: "flex", alignItems: "center", gap: 8, background: "rgba(61,107,46,.06)", borderRadius: 8, padding: "12px 16px", marginTop: 20 }}>
                        <IconCheck size={15} color="#3D6B2E" />
                        <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: "#3D6B2E" }}>
                          Vos informations sont à jour. Cliquez sur "Modifier" pour les changer.
                        </span>
                      </div>
                    )}
                  </div>

                  {/* Mot de passe */}
                  <div style={{ background: "white", borderRadius: 16, padding: "28px 32px", border: "1.5px solid rgba(28,16,8,.07)", marginTop: 20 }}>
                    <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 20, fontWeight: 700, marginBottom: 6 }}>Mot de passe</h3>
                    <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, color: "#7A5A3A", marginBottom: 16 }}>
                      Modifiez votre mot de passe pour sécuriser votre compte.
                    </p>
                    <button className="btn-outline" onClick={() => navigate("/forgot-password")}>
                      Changer le mot de passe
                    </button>
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}